<template>
  <div class="deals-filters">
    <div v-if="!isFund" class="filters-block">
      <h5>Deal Structure</h5>
      <div
        class="select-row"
        v-for="item in [{ name: 'Any' }].concat(optionsData.dealStructure)"
        :key="item.name"
      >
        <input
          type="radio"
          v-model="filters.dealStructure"
          :id="item.name"
          :value="item.name"
          name="dealStructure"
          @change="updateFilters"
        />
        <label :for="item.name">{{ item.name }}</label>
      </div>
    </div>

    <div class="filters-block">
      <h5>Regional focus</h5>
      <div class="select-all">
        <input
          type="checkbox"
          value="all"
          name="regionalFocus"
          v-model="filters.regionalFocus"
          id="allAfrica"
          @change="updateFilters"
        />
        <label for="allAfrica">All Africa</label>
      </div>
      <div
        class="select-row"
        v-for="item in optionsData.regionalFocus"
        :key="item.value"
      >
        <input
          type="checkbox"
          v-model="filters.regionalFocus"
          :id="item.value"
          :value="item.value"
          name="regionalFocus"
          @change="updateFilters"
        />
        <label :for="item.value">{{ item.name }}</label>
      </div>
    </div>

    <div class="filters-block">
      <h5>Deal size</h5>
      <div class="select-all">
        <input
          type="checkbox"
          value="all"
          v-model="filters.dealRanges"
          id="allRanges"
          name="dealRanges"
          @change="updateFilters"
        />
        <label for="allRanges">All ranges</label>
      </div>
      <div
        class="select-row"
        v-for="item in optionsData.dealRanges"
        :key="item.value"
      >
        <input
          type="checkbox"
          v-model="filters.dealRanges"
          :id="item.value"
          :value="item.value"
          name="dealRanges"
          @change="updateFilters"
        />
        <label :for="item.value">{{ item.name }}</label>
      </div>
    </div>

    <div class="filters-block">
      <h5>Sectors</h5>
      <el-form-item>
        <el-select
          v-model="filters.industrySectors"
          multiple
          filterable
          default-first-option
          placeholder="Select sector"
          @change="updateFiltersMulti"
        >
          <el-option
            v-for="item in optionsData.sectorOptions"
            :label="item.name"
            :value="item.name"
            :key="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
    </div>

    <div class="filters-block">
      <h5>Investing themes</h5>
      <el-form-item>
        <el-select
          v-model="filters.investingThemes"
          multiple
          filterable
          default-first-option
          placeholder="Select themes"
          @change="updateFiltersMulti"
        >
          <el-option
            v-for="item in optionsData.investingThemes"
            :label="item.name"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </div>

    <div class="controls">
      <button @click="saveFilters" class="btn btn-primary">
        Save as Default
      </button>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import optionsData from "@/data/options";

export default {
  name: "deals-filters",
  computed: {
    optionsData() {
      return optionsData;
    },
    interest() {
      return this.$store.getters["account/interest"];
    },
    appliedFilters() {
      return this.$store.getters["deals/filters"];
    },
    dealType() {
      return this.$store.getters["deals/dealType"];
    },
    isFund() {
      return this.dealType === "fund";
    },
  },
  data() {
    return {
      filters: {
        dealStructure: "",
        industrySectors: [],
        regionalFocus: [],
        dealRanges: [],
        investingThemes: [],
      },
    };
  },
  mounted() {
    this.applyExistingFilters();
  },
  methods: {
    applyExistingFilters() {
      this.filters = { ...this.appliedFilters };
    },
    updateFilters(v) {
      const value = v?.target?.value;
      if (!value) {
        return;
      }
      const name = v.target.name;
      const isChecked = v.target.checked;
      if (value === "all") {
        if (isChecked) {
          this.filters[name] = this.optionsData[name]
            .map((i) => i.value || i.name || i.label)
            .concat("all");
        } else {
          this.filters[name] = [];
        }
      }
      if (value !== "all") {
        if (isChecked) {
          if (
            this.optionsData[name].length === this.filters[name].length &&
            typeof this.filters[name] !== "string"
          ) {
            this.filters[name].push("all");
          }
        } else {
          this.filters[name] = this.filters[name].filter((i) => i !== "all");
        }
      }
      this.$store.dispatch("deals/updateFilters", this.filters);
    },
    updateFiltersMulti() {
      this.$store.dispatch("deals/updateFilters", this.filters);
    },
    saveFilters() {
      const interest = Object.assign(this.interest, {
        ..._.pick(this.filters, [
          "industrySectors",
          "dealRanges",
          "regionalFocus",
          "dealStructure",
          "investingThemes",
        ]),
      });

      if (!interest.dealStructure) delete interest.dealStructure;
      this.$store.dispatch("account/update", interest).then(() => {
        return this.$store.dispatch("messages/showSuccessMessage", {
          text: "Your deal filter preferences have been saved",
          confirmButtonText: "Ok",
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.deals-filters {
  padding-left: 10px;
  display: flex;
  flex-wrap: wrap;
}
.filters-block {
  display: inline-block;
  flex-basis: 200px;
  margin-right: 30px;
  padding-bottom: 15px;
  h5 {
    color: #0e3167;
    font-size: 14px;
  }
  label {
    margin-left: 5px;
    color: #7e8299;
    font-size: 14px;
  }
}
.controls {
  margin-top: 20px;
  flex: 1 1 100%;
  border-top: 1px solid #eee;
  padding-top: 20px;
  .btn-primary {
    cursor: pointer;
    &:hover {
      transition: all 0.2s;
      color: white;
      background: lighten(#0e3167, 10%) !important;
    }
  }
}
</style>
